module.exports = __webpack_public_path__ + "static/img/8.3043c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/changeBg/8.png
// module id = 6ITE
// module chunks = 0